import { SourceSystemType } from '../../../../foundation/models/enums/source-system-type.enum';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { FinanceRouteBuilderService } from '../../../../shared/services/route-builder/finance-route-builder.service';
import { FinanceRoutes } from '../../../finance-route-lookups';
import { Directive } from '@angular/core';

@Directive()
export abstract class FinanceBaseComponent extends BaseComponent {
    private _routeBuilder: FinanceRouteBuilderService;
    private sourceSystemTypes: SourceSystemType = new SourceSystemType();

    // Gets or sets the submitting flag when buttons are clicked
    public submitting = false;

    // Gets the finance route lookup object
    public FinanceRoutes = FinanceRoutes;

    /**
     * Initializes the page data for the component
     */
    protected abstract initPageData(object?: any);

    /**
     * Sets the results of the initialize
     * @param object The page data result object
     */
    protected abstract setPageData(object: any);

    /**
     * Formats the business unit lookup data to have the business unit code
     * appended in parans in front of the business unit code.  Inactive business units will also
     * have a * appended to the label.
     * @param data The business unit array
     */
    protected formatBusinessUnitLookups(data: any[]): any[] {

        // NOTE: PrimeNG requires label and value fields
        data.forEach(function(bu) {
            bu.value = bu.id;

            if (!bu.active) {
                bu.label = '*' + bu.id + ' - (' + bu.businessUnitCode + ') ' + bu.businessUnitName;
            } else {
                bu.label = bu.id + ' - (' + bu.businessUnitCode + ') ' + bu.businessUnitName;
            }
        });

        return data;
    }

    /**
     * Gets the route builder for Finance
     */
    public get routeBuilder(): FinanceRouteBuilderService {
        if (this._routeBuilder == undefined) {
            const fRouteBuilder: any = this.routeBuilderFactory.create(this.sourceSystemTypes.Finance.id);
            this._routeBuilder = fRouteBuilder;
        }

        return this._routeBuilder;
    }
}
